/**
 * Gutenberg Blocks
 *
 * All blocks related JavaScript files should be imported here.
 * You can create a new block folder in this dir and include code
 * for that block here as well.
 *
 * All blocks should be included here since this is the file that
 * Webpack is compiling as the input file.
 */

//  Import CSS.
//import './common.scss';

import './block/editor.scss';
import './block/style.scss';

import './block/block.js';
